import { Select as SelectComponent } from './Select'
import { _Footer } from './components/Footer'
import { _InputSearch } from './components/InputSearch'
import { _Header } from './components/Header'
import { _Body } from './components/Body'

export const Select = Object.assign(SelectComponent, {
  Header: _Header,
  Body: _Body,
  InputSearch: _InputSearch,
  Footer: _Footer
})

export default Select
